import { render, staticRenderFns } from "./TecMemo.vue?vue&type=template&id=5045db18&"
import script from "./TecMemo.vue?vue&type=script&lang=js&"
export * from "./TecMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports